<template>
  <div class="base-stations">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <h1>基站管理</h1>
          <div class="base-station-management">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" @click="handleAdd">新增基站</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="danger" @click="handleDelete">删除基站</el-button>
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="searchQuery"
                  placeholder="搜索基站 ID 或名称"
                  clearable
                  @clear="handleSearchClear"
                  empty-text="暂无基站"
                />
              </el-col>
            </el-row>

            <el-table
              :data="filteredBaseStations"
              style="width: 100%; margin-top: 20px;"
              @selection-change="handleSelectionChange"
              empty-text="暂无基站"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column prop="id" label="基站 ID" sortable />
              <el-table-column prop="name" label="基站名称" sortable />
              <el-table-column prop="x" label="X 坐标" sortable />
              <el-table-column prop="y" label="Y 坐标" sortable />

              <el-table-column prop="online" label="在线状态" sortable >
                <template #default="scope">
                  <el-tag :type="scope.row.online ? 'success' : 'danger'">
                    {{ scope.row.online ? '在线' : '离线' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="onlineTime" label="在线时间" sortable />
              <el-table-column prop="ip" label="IP 地址" sortable />
              <el-table-column prop="connectedTerminals" label="连接终端数" sortable />
              <el-table-column label="操作">
                <template #default="scope">
                  <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
  
  <el-dialog
    v-model="dialogVisible"
    :title="editMode ? '编辑基站' : '新增基站'"
    width="30%"
  >
    <el-form :model="newBaseStation" label-width="100px">
      <el-form-item label="基站 ID">
        <el-input v-model="newBaseStation.id" />
      </el-form-item>
      <el-form-item label="基站名称">
        <el-input v-model="newBaseStation.name" />
      </el-form-item>
      <el-form-item label="X 坐标">
        <el-input-number v-model="newBaseStation.x" :min="0" />
      </el-form-item>
      <el-form-item label="Y 坐标">
        <el-input-number v-model="newBaseStation.y" :min="0" />
      </el-form-item>
      <!-- <el-form-item label="在线状态">
        <el-switch v-model="newBaseStation.online" />
      </el-form-item> -->
      <el-form-item label="IP 地址">
        <el-input v-model="newBaseStation.ip" />
      </el-form-item>
    </el-form>
    <!-- <template #footer> -->
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmAdd">确认</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseStations',
  data() {
    return {
      dialogVisible: false,
      editMode: false, // 区分编辑和新增模式
      newBaseStation: {}, // 存储新增或编辑的基站数据
      baseStations: [
        { id: '001', name: '基站A', x: 10, y: 20, z: 30, online: true, onlineTime: '12:34:56', ip: '192.168.2.101', connectedTerminals: 5 },
        { id: '002', name: '基站B', x: 15, y: 25, z: 35, online: false, onlineTime: '11:22:33', ip: '192.168.2.102', connectedTerminals: 0 },
        { id: '003', name: '基站C', x: 20, y: 30, z: 40, online: true, onlineTime: '10:20:30', ip: '192.168.2.103', connectedTerminals: 3 },
        { id: '004', name: '基站D', x: 25, y: 35, z: 45, online: true, onlineTime: '09:18:27', ip: '192.168.2.104', connectedTerminals: 7 },
        { id: '005', name: '基站E', x: 30, y: 40, z: 50, online: false, onlineTime: '08:16:24', ip: '192.168.2.105', connectedTerminals: 0 }
      ],
      searchQuery: '',
      selectedBaseStations: []
    };
  },
  computed: {
    filteredBaseStations() {
      return this.baseStations.filter(station => {
        return station.id.includes(this.searchQuery) || station.name.includes(this.searchQuery);
      });
    }
  },
  methods: {
    handleAdd() {
      this.editMode = false; // 设置为新增模式
      const newId = String(this.baseStations.length + 1).padStart(3, '0');
      const newIp = `192.168.2.${String(this.baseStations.length + 1)}`;
      this.newBaseStation = {
        id: newId,
        name: `基站 ${newId}`,
        x: 0,
        y: 0,
        z: 0,
        online: true,
        onlineTime: '00:00:00',
        ip: newIp,
        connectedTerminals: Math.floor(Math.random() * 12),
      }; // 初始化新增基站对象
      this.dialogVisible = true;
    },
    handleConfirmAdd() {
      if (!this.newBaseStation.id || !this.newBaseStation.name) {
        this.$message.error("请输入基站 ID 和 名称");
        return;
      }
      if (this.editMode) {
        const index = this.baseStations.findIndex(b => b.id === this.newBaseStation.id);
        if (index !== -1) {
          this.baseStations.splice(index, 1, { ...this.newBaseStation }); // 更新现有数据
          this.$message.success(`基站 ${this.newBaseStation.name} 信息已更新`);
        }
      } else {
        this.baseStations.push({ ...this.newBaseStation }); // 新增数据
        this.$message.success(`新增基站 ${this.newBaseStation.name} 成功`);
      }
      this.dialogVisible = false;
    },
    handleDelete() {
      if (this.selectedBaseStations.length === 0) {
        this.$message.warning('请选择要删除的基站');
        return;
      }
      // 删除选中的基站
      this.baseStations = this.baseStations.filter(
        station => !this.selectedBaseStations.some(selected => selected.id === station.id)
      );
      this.selectedBaseStations = []; // 清空选中状态
      this.$message.success('删除基站成功');
    },
    handleSelectionChange(selection) {
      this.selectedBaseStations = selection;
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.editMode = true; // 设置为编辑模式
      this.newBaseStation = { ...row }; // 预填充选中基站数据到表单
    },
    handleConfirmAdd() {
      if (!this.newBaseStation.id || !this.newBaseStation.name) {
        this.$message.error("请输入基站 ID 和 名称");
        return;
      }
      if (this.editMode) {
        const index = this.baseStations.findIndex(b => b.id === this.newBaseStation.id);
        if (index !== -1) {
          this.baseStations.splice(index, 1, { ...this.newBaseStation }); // 更新现有数据
          this.$message.success(`基站 ${this.newBaseStation.name} 信息已更新`);
        }
      } else {
        this.baseStations.push({ ...this.newBaseStation }); // 新增数据
        this.$message.success(`新增基站 ${this.newBaseStation.name} 成功`);
      }
      this.dialogVisible = false;
      this.editMode = false; // 重置模式
    },
  },
}
</script>

<style scoped>
.base-stations {
  padding: 20px;
}

.base-station-management {
  margin-top: 20px;
}
</style>
